import {FormHelperText, Typography, Grid, Box, Tooltip, IconButton} from '@mui/material';
import React, {useEffect} from 'react';
import InfoIcon from '@mui/icons-material/Info';
import {UPDATES} from '../../shared/UPDATES';
import {recommendFieldsType} from '../../features/recommendations/CreateRecommend/recommendFields';
import {TaskUrgencyEnum} from '../../schema-types/globalTypes';
import AutoField, {ActionType} from '../AutoForm/AutoFieldNew';
import {useAutoForm} from '../AutoForm/useAutoForm';

export const URGENCY_OPTIONS = [
  {
    value: TaskUrgencyEnum.NORMAL,
    label: 'Normal',
  },
  {
    value: TaskUrgencyEnum.TAX_YEAR_SENSITIVE,
    label: 'Tax year sensitive',
  },
  {
    value: TaskUrgencyEnum.URGENT,
    label: 'Urgent',
  },
];

export const Urgency: React.FC<{direction: 'row' | 'column'}> = ({direction = 'row'}) => {
  // usually this will be the type, but not always
  const {values, setFieldValue} = useAutoForm<recommendFieldsType>();

  if (!values?.urgency) {
    values.urgency = TaskUrgencyEnum.NORMAL;
  }
  useEffect(() => {
    if (values.urgency === TaskUrgencyEnum.TAX_YEAR_SENSITIVE) {
      setFieldValue(
        UPDATES._065,
        'urgencyReason',
        'Tax year end',

        true
      );
    }
  }, [values.urgency]);

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">Urgency:</Typography>
        <Tooltip title="Urgency box should not be abused by Advisers, this should only be used in such cases as approaching tax year end.">
          <IconButton size="large">
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Grid
        spacing={2}
        direction={direction}
        alignItems={direction === 'row' ? 'center' : 'stretch'}
        container
      >
        <Grid item xs={6}>
          <AutoField
            field={{
              type: ActionType.radioGroup,
              id: 'urgency',
              label: 'Urgency',
              options: URGENCY_OPTIONS,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <AutoField
            field={{
              id: 'urgencyReason',
              type: ActionType.text,
              initialValue: '',
              labelOnTop: true,
              size: 'small',
              label: 'Urgency Reason',
              disabled: values.urgency === TaskUrgencyEnum.NORMAL,
            }}
          />
          <FormHelperText>Why is this urgent?</FormHelperText>
        </Grid>
      </Grid>
    </>
  );
};
